import { Box, BoxProps } from '@material-ui/core';
import { Alert, AlertProps } from '@material-ui/lab';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface CustomAlertProps extends Omit<AlertProps, 'title'> {
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  boxProps?: BoxProps;
  children?: React.ReactNode;
}

export const CustomAlert = ({ title, description, boxProps, children, ...props }: CustomAlertProps) => {
  const { customBorderRadius } = useCustomTheme();

  return (
    <Box width={'100%'} {...boxProps}>
      <Alert {...props} style={{ borderRadius: customBorderRadius.paper, ...props.style }}>
        <Box width={'100%'} minWidth={0}>
          <Font variant="body2" display="block" style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
            {typeof title === 'string' ? <Text strong tId={title} /> : title}
          </Font>
          {description && (
            <Font
              variant="body2"
              display="block"
              style={{ overflowWrap: 'anywhere', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}
            >
              {typeof description === 'string' ? <Text tId={description} /> : description}
            </Font>
          )}
        </Box>
        {children}
      </Alert>
    </Box>
  );
};
